import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AreaFormacaoService } from '../../api/services/area-formacao.service';
import { Button } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { CommonModule } from '@angular/common';
import { Toast } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-selecionar-areas-formacao',
  imports: [Button, CommonModule, MultiSelectModule, ReactiveFormsModule, Toast],
  standalone: true,
  templateUrl: './selecionar-areas-formacao.component.html',
  styleUrls: ['./selecionar-areas-formacao.component.scss'],
})
export class SelecionarAreasFormacaoComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  messageService = inject(MessageService);
  areaFormacaoService = inject(AreaFormacaoService);
  fb = inject(FormBuilder);

  areasFormacao: any[] = [];
  areasFormacaoForm!: FormGroup;

  constructor() {}

  ngOnInit() {
    this.initializeForm();
    // this.loadAreasFormacao();

    // Carregar áreas já associadas (passadas via `config.data`)
    if (this.config.data?.selectedAreas) {
      console.log('Areas selecionadas:', this.config.data.selectedAreas);
      this.areasFormacaoForm.patchValue({
        selectedAreas: this.config.data.selectedAreas,
      });
    }

    // Carregar todas as áreas de formação
    if(this.config.data?.areasFormacao) {
      this.areasFormacao = this.config.data?.areasFormacao?.data?.map((area: any) => ({
        label: area.designacao,
        value: area.id,
      }));

    }
  }

  initializeForm() {
    this.areasFormacaoForm = this.fb.group({
      selectedAreas: [[], Validators.required], // Validação para garantir que pelo menos uma área seja selecionada
    });
  }

  loadAreasFormacao() {
    this.areaFormacaoService
      .list({
        pageNumber: 1,
        pageSize: 1000,
        OrderBy: 'id desc',
      })
      .subscribe(
        (res: any) => {
          this.areasFormacao = res.data.map((area: any) => ({
            label: area.areaFormacao.designacao,
            value: area.areaFormacao.id,
          }));
        },
        (error: any) => {
          console.error('Erro ao carregar áreas de formação:', error);
        }
      );
  }

  confirmarSelecao() {
    if (this.areasFormacaoForm.valid) {
      // Retornar as áreas selecionadas para o componente principal
      this.ref.close(this.areasFormacaoForm.value.selectedAreas);
    } else {
      // Exibir mensagem de erro se nenhuma área for selecionada
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Por favor, selecione pelo menos uma área de formação.',
      });
    }

  }

  cancelar() {
    // Fechar a modal sem salvar alterações
    this.ref.close();
  }
}
